import { createContext, useContext, useState, useEffect } from "react";
import { authAPI } from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("kq_token");
    if (token) {
      authAPI.me()
        .then(r => setUser(r.data.data))
        .catch(() => { localStorage.removeItem("kq_token"); localStorage.removeItem("kq_user"); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (phone, password) => {
    const r = await authAPI.login({ phone, password });
    localStorage.setItem("kq_token", r.data.data.token);
    localStorage.setItem("kq_user",  r.data.data.user_id);
    setUser(r.data.data);
    return r.data.data;
  };

  const register = async (body) => {
    const r = await authAPI.register(body);
    localStorage.setItem("kq_token", r.data.data.token);
    localStorage.setItem("kq_user",  r.data.data.user_id);
    // fetch full profile
    const me = await authAPI.me();
    setUser(me.data.data);
    return r.data.data;
  };

  const logout = () => {
    localStorage.removeItem("kq_token");
    localStorage.removeItem("kq_user");
    setUser(null);
  };

  // Guest auto-login (for quick delivery form)
  // Returns { ...userData, isNew: bool, generatedPassword: string|null }
  const guestLogin = async (name, phone) => {
    const email    = `${phone.replace(/\D/g,"")}@kwikkie.com`;
    const password = phone.replace(/\D/g,"") + "_kq2025";
    try {
      const data = await register({ name, phone, email, password });
      return { ...data, isNew: true, generatedPassword: password };
    } catch (e) {
      if (e.response?.data?.message?.includes("already registered")) {
        const data = await login(phone, password);
        return { ...data, isNew: false, generatedPassword: null };
      }
      throw e;
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, guestLogin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
